import router from '../router'
import store from '../store'
import api from '../api'

function initViewModel (settings) {
  let data = {}
  let vm = {
    shareCode: '',
    shareName: ''
  }
  if (settings) {
    if (settings.vm) {
      vm = settings.vm
      if (vm.shareCode === undefined) {
        vm.shareCode = ''
      }
      if (vm.shareName === undefined) {
        vm.shareName = ''
      }
    }
    if (settings.activeName) {
      data.activeName = settings.activeName
    }
    if (settings.pageName) {
      if (
        Object.prototype.toString.call(settings.pageName) === '[object Array]'
      ) {
        for (var i in settings.pageName) {
          vm[settings.pageName[i]] = {
            Items: [],
            PageInfo: {
              PageIndex: 1,
              PageSize: 50,
              TotalCount: 0
            }
          }
        }
      } else {
        vm[settings.pageName] = {
          Items: [],
          PageInfo: {
            PageIndex: 1,
            PageSize: 50,
            TotalCount: 0
          }
        }
      }
    }
  }

  var query = router.currentRoute.query
  if (query) {
    for (var q in query) {
      vm[q] = query[q]
    }
  }

  data.vm = vm
  data.loading = false
  return data
}

function getParams (vm) {
  var query = router.currentRoute.query
  if (query) {
    for (var q in query) {
      vm[q] = query[q]
    }
  }
}

function isWeixin () {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
}

function isPhone () {
  var w = window.document.body.clientWidth
  return w < 900
}

function favorite (type, name, relid, relurl, shareCode, shareName, reportTime, hangYeMingCheng) {
  var doc = document.querySelector('#i' + relid)
    
  if(type === '自选股'){
    if (doc.className === 'el-icon-success favorite') {
      doc.className = 'el-icon-news favorite'
    } else {
      doc.className = 'el-icon-success favorite'
    }
  }
  
  if(type === '研究报告'){
    if (doc.className === 'el-icon-star-on favorite') {
      doc.className = 'el-icon-star-off favorite'
    } else {
      doc.className = 'el-icon-star-on favorite'
    }
  }

  if(type === '首发申报'){
    if (doc.className === 'el-icon-star-on favorite') {
      doc.className = 'el-icon-star-off favorite'
    } else {
      doc.className = 'el-icon-star-on favorite'
    }
  }
/*   if(type === '抄作业'){
    if (doc.className === 'el-icon-star-on favorite') {
      doc.className = 'el-icon-star-off favorite'
    } else {
      doc.className = 'el-icon-star-on favorite'
    }
  } */

  if(type === '公司公告'){
    if (doc.className === 'el-icon-star-on favorite') {
      doc.className = 'el-icon-star-off favorite'
    } else {
      doc.className = 'el-icon-star-on favorite'
    }
  }
  if(type === '机构调研'){
    if (doc.className === 'el-icon-star-on favorite') {
      doc.className = 'el-icon-star-off favorite'
    } else {
      doc.className = 'el-icon-star-on favorite'
    }
  }
  api.favorite
    .addOrDelete(type, name, relid+'', relurl, shareCode, shareName, reportTime, hangYeMingCheng)
    .then(r => {
      store.commit('initFavorite')
    })
}


function favoriteCheck (type, relid) {
  var r = store.state.favorite
  var f = false
  if (r) {
    r.forEach(x => {
      if (x.type === type && x.relid == relid) {
        f = true
      }
    })
  }
  return f
}

export default {
  initViewModel,
  getParams,
  isWeixin,
  isPhone,
  favorite,
  favoriteCheck
}



// WEBPACK FOOTER //
// ./src/core/core.js